const IPV4_REGEX =
  /^([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])(\.([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])){3}$/;

const IPV6_REGEX = /^([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$/;

export const isIpV4 = (ip: string) => {
  return IPV4_REGEX.test(ip.trim());
};

export const isIpV6 = (ip: string) => {
  return IPV6_REGEX.test(ip.trim());
};
